import { GMButton } from '../../Button';
import { useLocalization } from '../../../context/Localization/localization';
import { DialogCancelRetryProps } from './DialogRetryCancel.types';
import { GMDialog } from '..';

/**
 * A Dialog component that presents the user with cancel and retry options.
 *
 * @param ariaLabel - {@link DialogCancelRetryProps.ariaLabel ariaLabel} description.
 * @param title - {@link DialogCancelRetryProps.title title} description.
 * @param open - {@link DialogCancelRetryProps.open open} description.
 * @param onCancel - {@link DialogCancelRetryProps.onCancel onCancel} description.
 * @param onRetry - {@link DialogCancelRetryProps.onRetry onRetry} description.
 * @param className - {@link DialogCancelRetryProps.className className} description.
 * @param children - {@link DialogCancelRetryProps.children children} description.
 */
const DialogRetryCancel = ({
    ariaLabel,
    title,
    open,
    className,
    onCancel,
    onRetry,
    children,
}: DialogCancelRetryProps) => {
    const Localization = useLocalization();

    return (
        <GMDialog
            ariaLabel={ariaLabel}
            title={title}
            className={className}
            open={open}
            onClose={onCancel}
            actions={[
                <GMButton
                    id={Localization.Cancel}
                    title={Localization.Cancel}
                    ariaLabel={Localization.Cancel}
                    styleType={'secondary'}
                    onClick={onCancel}
                >
                    {Localization.Cancel}
                </GMButton>,
                <GMButton
                    id={Localization.Retry}
                    title={Localization.Retry}
                    ariaLabel={Localization.Retry}
                    onClick={onRetry}
                >
                    {Localization.Retry}
                </GMButton>,
            ]}
        >
            {children}
        </GMDialog>
    );
};

export default DialogRetryCancel;